import { render, staticRenderFns } from "./ExpiryModal.vue?vue&type=template&id=4ad32432&"
import script from "./ExpiryModal.vue?vue&type=script&lang=ts&"
export * from "./ExpiryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports